const localPermissions = {
  DISTRIBUTOR_RENTAL_READ: {
    category: 'distributor_rental',
    title: 'distributor_rental_read',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RENTAL_CREATE: {
    category: 'distributor_rental',
    title: 'distributor_rental_create',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RENTAL_UPDATE: {
    category: 'distributor_rental',
    title: 'distributor_rental_update',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RENTAL_DELETE: {
    category: 'distributor_rental',
    title: 'distributor_rental_delete',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RECYCLING_READ: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_read',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RECYCLING_CREATE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_create',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RECYCLING_UPDATE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_update',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_RECYCLING_DELETE: {
    category: 'distributor_recycling',
    title: 'distributor_recycling_delete',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_EXTRACT_REPAIR_FILE: {
    category: 'distributor_extract_management',
    title: 'distributor_extract_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ADD_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_add_collaborator',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_UPDATE_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_update_collaborator',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_DELETE_COLLABORATOR: {
    category: 'distributor_collaborator_management',
    title: 'distributor_delete_collaborator',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ADD_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_add_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_UPDATE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_update_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_CLOSE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_close_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ARCHIVE_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_archive_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_REASSIGN_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_reassign_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_COMMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_management',
    title: 'distributor_comment_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_VIEW_ALL_SUMMARY_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_all_summary_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_VIEW_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_attachment_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_VIEW_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_view_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_PRINT_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_print_attachment_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ADD_ATTACHMENT_REPAIR_FILE: {
    category: 'distributor_repair_file_view',
    title: 'distributor_add_attachment_repair_file',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ACCOUNT_READ_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_account_read_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_ACCOUNT_UPDATE_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_account_update_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_TRANSPORTER_CREATE_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_transporter_create_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_TRANSPORTER_READ_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_transporter_read_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_TRANSPORTER_UPDATE_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_transporter_update_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  },
  DISTRIBUTOR_TRANSPORTER_DELETE_PERMISSION: {
    category: 'distributor_platform_management',
    title: 'distributor_transporter_delete_permission',
    type: 'DISTRIBUTOR_BOOMERANG'
  }
}

export default localPermissions
